<style scoped lang="less">
  .is-handle {
    height: 30px;
    font-size: 0.8rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 2px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 50px;
    color: #FFF;
    background-color: #4267b2;
    position: relative;
    top: 21px;
    left: 20px;
  }
  @media screen and (max-width: 768px) {
    .is-reply {
      position: absolute;
      right: 15px;
      bottom: 25px;
      top: inherit;
    }
    .is-handle {
      left:inherit;
      position: absolute;
      right: 15px;
      bottom: 5px;
      top: inherit;
    }
  }
</style>
<template>
  <div class="content mb-0 p-0">
    <div class="columns">
      <div
        class="column is-12"
        style="padding-bottom:0;"
      >
        <div
          class="box mb-0 is-paddingless"
          @click.stop="expandConversation()"
        >
          <div
            class="columns mb-0"
            style="position: relative"
            :class="{'has-border':isExpanded}"
          >
            <div class="column is-6 email-conversation-from">
              <strong>From:</strong> {{ replyName() }}<br>
              <strong>To:</strong> {{ toName() }}
            </div>
            <div class="column is-4 email-conversation-from">
              <strong>Received:</strong> {{ conversation.received_date }}
            </div>
            <div
              class="column is-1 is-reply is-flex box"
              @click="replyTo"
            >
              Reply
            </div>
            <div
              class="column is-1 is-handle is-flex box"
              @click="handle"
            >
              Handle
            </div>
          </div>
          <div
            v-show="isExpanded"
            ref="body"
            class="email-body"
            style="padding:20px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EmailConversation',
    components: {
    },
    props: ['token', 'user', 'conversation'],
    data () {
      return {
        isExpanded: false,
        edit: false,
        loading: true,
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted() {
    },
    methods: {
      toName() {
        return this.conversation.to_name ? this.conversation.to_name : this.conversation.to
      },
      replyName() {
        return this.conversation.from_name ? this.conversation.from_name : this.conversation.from
      },
      replyTo(e) {
        this.$emit('replyTo', {'conv_id': this.conversation.id, 'reply_to': this.conversation.from_name ? this.conversation.from_name : this.conversation.from})
        e.stopPropagation()
      },
      handle(e) {
        if (confirm('Are you sure you want to handle this email without responding?')) {
          this.$emit('handle', {
            'conv_id': this.conversation.id,
            'reply_to': this.conversation.from_name ? this.conversation.from_name : this.conversation.from
          })
        }
        e.stopPropagation()
      },
      expandConversation(event) {
        this.$refs.body.innerHTML = this.conversation.body
        this.isExpanded = !this.isExpanded
      },
    }
  }
</script>
